import React, { ReactNode, useEffect } from "react"
import {
  Box, Flex, Heading, Stack,
} from "@chakra-ui/react"
import Modal from "components/dialogs/Modal"
import Icon from "components/elements/Icon"
import { useHistory } from "react-router-dom"
import ConfettiExplosion from "components/ConfettiExplosion"
import Button from "components/Buttons/Button"

type Props = {
  onHide: () => void
  title?: string
  heading?: string
  body?: ReactNode
}

export const PaymentSuccessful = ({
  onHide,
  title = "Message Credits",
  heading = "Credits Added",
  body = "Your message credits have been successfully refilled.",
}: Props) => {
  const history = useHistory()

  // Remove the query params from the URL that the Stripe redirect adds
  useEffect(() => {
    if (history.location.search) {
      history.replace({
        pathname: history.location.pathname,
        search: "",
      })
    }
  }, [history])

  return (
    <ConfettiExplosion>
      <Modal
        title={title}
        show
        hide={onHide}
        enableOverlay={false}
        size="lg"
        header={<></>}
      >
        <Stack alignItems="center" textAlign="center" spacing={8}>
          <Flex alignItems="center" justifyContent="center" flexDirection="column" gap={2}>
            <Icon size={14} icon="portal-confirmed" color="blue.500" />
            <Heading mb={2} size="lg" fontWeight="semibold">{heading}</Heading>
          </Flex>
          <Box fontSize="lg" mb={4}>{body}</Box>
          <Button onClick={onHide} size="lg" px={10}>Continue</Button>
        </Stack>
      </Modal>
    </ConfettiExplosion>
  )
}

export default PaymentSuccessful
